"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Service = exports.wire = exports.Wire = exports.Provider = exports.createInstance = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var createInstance = function createInstance() {
  var Context = _react.default.createContext({});

  function find(dependencies, services) {
    return dependencies.reduce(function (result, dependency) {
      result[dependency] = services[dependency];
      return result;
    }, {});
  }

  function Provider(_ref) {
    var services = _ref.services,
        children = _ref.children;
    return _react.default.createElement(Context.Provider, {
      value: services
    }, children);
  }

  function Wire(_ref2) {
    var _this = this;

    var services = _ref2.services;
    return _react.default.createElement(Context.Consumer, null, function (_services) {
      return _this.props.render(find(services, _services));
    });
  }

  function wire(dependencies, Component) {
    return function (props) {
      return _react.default.createElement(Context.Consumer, null, function (services) {
        return _react.default.createElement(Component, _extends({}, find(dependencies, services), props));
      });
    };
  }

  var Service =
  /*#__PURE__*/
  function () {
    function Service() {
      _classCallCheck(this, Service);

      _defineProperty(this, "_changeListeners", []);
    }

    _createClass(Service, [{
      key: "addChangeListener",
      value: function addChangeListener(changeListener) {
        var _this2 = this;

        this._changeListeners.push(changeListener);

        return function () {
          return _this2._unregisterListener(changeListener);
        };
      }
    }, {
      key: "runChangeListeners",
      value: function runChangeListeners() {
        this._changeListeners.forEach(function (listener) {
          return listener();
        });
      }
    }, {
      key: "_unregisterListener",
      value: function _unregisterListener(changeListener) {
        this._changeListeners = this._changeListeners.filter(function (listener) {
          return listener !== changeListener;
        });
      }
    }]);

    return Service;
  }();

  return {
    Provider: Provider,
    Wire: Wire,
    wire: wire,
    Service: Service
  };
};

exports.createInstance = createInstance;

var _createInstance = createInstance(),
    Provider = _createInstance.Provider,
    Wire = _createInstance.Wire,
    wire = _createInstance.wire,
    Service = _createInstance.Service;

exports.Service = Service;
exports.wire = wire;
exports.Wire = Wire;
exports.Provider = Provider;